import React from 'react';
import PropTypes from 'prop-types';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import {
  SIGNED_IN_HOME_PATH,
  getSignUpRedirectPath,
  getSignInRedirectPath,
} from 'routes';

import withCurrentPath from 'hoc/withCurrentPath';

import { CrossIcon, MenuIcon } from '@datacamp/waffles-icons';

import Button from 'components/buttons/Button';

import {
  A,
  Backdrop,
  CloseButton,
  Container,
  FooterLink,
  List,
  ListItem,
  MenuButton,
  Plans,
  Section,
  Wrapper,
} from 'components/Navbar/MobileStyles';

class Mobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: false,
    };

    this.toggleDisplay = this.toggleDisplay.bind(this);
  }

  toggleDisplay() {
    const { display } = this.state;
    this.setState({ display: !display }, () => {
      /* eslint-disable no-shadow */
      const { display } = this.state;
      /* eslint-enable no-shadow */
      if (display) {
        disableBodyScroll(document.querySelector('.js-scroll'));
      } else {
        enableBodyScroll(document.querySelector('.js-scroll'));
      }
    });
  }

  render() {
    const { display } = this.state;
    const { navigationInfo, currentPath, isSignedIn } = this.props;
    return (
      <>
        <Wrapper
          className={`${display ? '' : 'isHidden'} js-scroll`}
          style={{ overflowY: 'scroll' }}
          tabIndex="-1"
          role="dialog"
          id="mobile_nav"
        >
          <div role="document">
            <Container>
              <CloseButton
                type="button"
                className="close"
                aria-label="Close"
                onClick={this.toggleDisplay}
              >
                <CrossIcon className="icon" size={14} />
              </CloseButton>

              <Section>
                <h5 className="dc-chapeau-title">Learn</h5>
                <List>
                  <ListItem>
                    <A href="/courses">
                      Courses ({navigationInfo.course_count})
                    </A>
                  </ListItem>
                  <ListItem>
                    <A href="/tracks/skill">
                      Skill Tracks ({navigationInfo.skills_track_count})
                    </A>
                  </ListItem>
                  <ListItem>
                    <A href="/tracks/career">
                      Career Tracks ({navigationInfo.career_track_count})
                    </A>
                  </ListItem>
                  <ListItem>
                    <A href="/instructors">
                      Instructors ({navigationInfo.instructor_count})
                    </A>
                  </ListItem>
                </List>
              </Section>

              <Section>
                <h5 className="dc-chapeau-title">Pricing</h5>
                <List>
                  <ListItem>
                    <A
                      className="ds-snowplow-li-main-menu-pricing"
                      href="/pricing"
                    >
                      See our plans
                    </A>
                  </ListItem>
                </List>

                <Plans className="dc-chapeau-title">Plans</Plans>
                <List>
                  <ListItem>
                    <A
                      className="ds-snowplow-li-main-menu-for-business"
                      href="/groups/business"
                    >
                      For Business
                    </A>
                  </ListItem>
                  <ListItem>
                    <A
                      className="ds-snowplow-li-main-menu-for-students"
                      href="/groups/education"
                    >
                      For Students
                    </A>
                  </ListItem>
                </List>
              </Section>

              {isSignedIn ? (
                <FooterLink href={SIGNED_IN_HOME_PATH}>My Dashboard</FooterLink>
              ) : (
                <>
                  <Section>
                    <Button
                      bg={waffles => waffles.theme.colors.primary}
                      textColor={waffles => waffles.theme.colors.white}
                      href={getSignUpRedirectPath(currentPath)}
                      width="100%"
                    >
                      Create Free Account
                    </Button>
                  </Section>

                  <FooterLink
                    className="dc-u-d-b dc-u-p-16 dc-link--grey-dark"
                    href={getSignInRedirectPath(currentPath)}
                  >
                    Sign in
                  </FooterLink>
                </>
              )}
            </Container>
          </div>

          <Backdrop
            className={`${display ? '' : 'isHidden'}`}
            onClick={this.toggleDisplay}
          />
        </Wrapper>

        <MenuButton
          data-toggle="modal"
          data-target="#mobile_nav"
          onClick={this.toggleDisplay}
        >
          <MenuIcon color="#9fadc5" size={38} />
        </MenuButton>
      </>
    );
  }
}

Mobile.propTypes = {
  navigationInfo: PropTypes.shape({
    course_count: PropTypes.number.isRequired,
    career_track_count: PropTypes.number.isRequired,
    skills_track_count: PropTypes.number.isRequired,
    instructor_count: PropTypes.number.isRequired,
    featured_courses: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
      })
    ).isRequired,
    featured_tracks: PropTypes.arrayOf(
      PropTypes.shape({
        title_with_subtitle: PropTypes.string.isRequired,
        category: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
      })
    ).isRequired,
    featured_instructors: PropTypes.arrayOf(
      PropTypes.shape({
        full_name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
      })
    ),
  }).isRequired,
  currentPath: PropTypes.string.isRequired,
  isSignedIn: PropTypes.bool,
};

Mobile.defaultProps = {
  isSignedIn: undefined,
};

export default withCurrentPath(Mobile);
